/*
MIT License

Copyright (c) 2023 Artem Churyukin

Permission is hereby granted, free of charge, to any person obtaining a copy
of this software and associated documentation files (the "Software"), to deal
in the Software without restriction, including without limitation the rights
to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
copies of the Software, and to permit persons to whom the Software is
furnished to do so, subject to the following conditions:

The above copyright notice and this permission notice shall be included in all
copies or substantial portions of the Software.

THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
SOFTWARE.
*/

import psl_ui from './psl_ui.js';
import psl_events from './psl_events.js';
import {wait} from "./psl_polyfills.js";

psl_ui.templates.add('psl_pages.container','<div class="psl_pages"></div>');
psl_ui.templates.add('psl_pages.page','<div class="psl_page"></div>');

const _container=psl_ui.templates.render('psl_pages.container');
document.body.appendChild(_container.el);
		
class Page extends psl_events.class{
	constructor(){
		super();
		this._view=psl_ui.templates.render('psl_pages.page');
		this._view.el.controller=this;
		this._rpoints=this._view.rpoints;
	}
	get view(){
		return this._view.el;
	}
	set view(_){}
	get shown(){
		return !!this._shown;
	}
	set shown(_){}
	async show(){
		this.emit('show');
	}
	async hide(){
		this.emit('hide');
	}
	async push(){
		this.emit('push');
	}
}
	
let _shown;
const _map=new Map();
const _events=new psl_events.class();
	
const _ext={
	view:_container.el,
	events:_events,
	add:(uid,page)=>{
		_map.set(uid,page);
		_container.el.appendChild(page.view);
		page.view.style.opacity=0;
		page.view.style.display='none';
		page._psl_pages_uid=uid;
	},
	has:uid=>{
		return _map.has(uid);
	},
	show:async (uid,load,args=[])=>{
		if(uid instanceof Page) uid=uid._psl_pages_uid;
		
		if(_shown===uid){
			_map.get(_shown).push();
			return;
		}
		
		let old_page=_map.get(_shown);
		let new_page=_map.get(uid);
		new_page.view.style.display='';
		new_page.view.style.zIndex=200;
		await new_page.show(...args);
		await wait(100);
		_events.emit('show',[uid]);
		new_page.view.style.opacity='';
		await wait(500);
		_shown=uid;
		await wait(100);
		
		if(old_page){
			old_page.hide();
			old_page.view.style.opacity=0;
			old_page.view.style.display="none";
		}
		new_page.view.style.zIndex='';
	},
	resize(){
		let width=window.innerWidth;
		let height=window.innerHeight;
		
		let scale=Math.min(width/1920,height/1080);
		
		_container.el.style.transform=`translate3d(${Math.max(0,(window.innerWidth-1920*scale)/2)}px,${Math.max(0,(window.innerHeight-1080*scale)/2)}px,0px) scale3d(${scale},${scale},1)`;
		_ext.scale=scale;
	},
	scale:1,
	page:Page,
};

window.addEventListener('resize',_ext.resize);

_ext.resize();

export default _ext;
